import { Camera, Eye, Mic, Monitor, Volume2 } from 'lucide-react';
import { policyLabel } from '../lib/format';
import type { Device, Policy } from '../lib/types';

export function PolicyBadge({ policy }: { policy: Policy }) {
  const tone = policy.onBreak ? 'break' : policy.schoolTime ? 'school' : 'free';
  return <span className={`badge ${tone}`}>{policyLabel(policy)}</span>;
}

/** An extension checks in every minute rather than staying connected, so "online" is "seen in the last few minutes". */
export const extOnline = (d: Device) => !!d.online || Date.now() - d.lastSeenAt < 180_000;

/** Small icons for what an online device is sharing. */
export function Sharing({ device }: { device: Device }) {
  const s = device.status;
  if (device.kind === 'extension') return <span className="muted small">{extOnline(device) ? 'Online' : 'Offline'}</span>;
  if (!device.online) return <span className="muted small">Offline</span>;
  const items = [
    { on: s?.screen, icon: <Monitor size={15} />, label: 'Screen' },
    { on: s?.camera, icon: <Camera size={15} />, label: 'Camera' },
    { on: s?.mic, icon: <Mic size={15} />, label: 'Microphone' },
    { on: s?.audio, icon: <Volume2 size={15} />, label: 'Computer sound' },
  ];
  return (
    <span className="sharing">
      {items.map((i) => (
        <span key={i.label} className={i.on ? 'on' : 'off'} title={`${i.label}: ${i.on ? 'shared' : 'not shared'}`}>
          {i.icon}
        </span>
      ))}
      {!!s?.viewers && (
        <span className="on" title="Someone is watching live">
          <Eye size={15} />
        </span>
      )}
    </span>
  );
}
